import { appInsights } from "./index";

export const WIDGET_EVENT_NAMES = [
  "widget.loaded",
  "trigger.clicked",
  "conversation.created",
  "message.sent",
  "message.response.start",
  "message.response.end",
  "link.clicked",
] as const;

export type WidgetEventName = (typeof WIDGET_EVENT_NAMES)[number];

export function isWidgetEventName(name: string): name is WidgetEventName {
  return (WIDGET_EVENT_NAMES as readonly string[]).includes(name);
}

function normalizeAttributes(
  attributes: Record<string, string | number | boolean>,
): Record<string, string> {
  return Object.fromEntries(
    Object.entries(attributes).map(([key, value]) => [key, String(value)]),
  );
}

export function trackWidgetEvent(
  eventName: WidgetEventName,
  attributes: Record<string, string | number | boolean> = {},
): void {
  try {
    const properties = normalizeAttributes(attributes);
    appInsights?.trackEvent({
      name: eventName,
      properties,
    });
  } catch (error) {
    if (process.env.NODE_ENV === "development") {
      console.debug("[Telemetry] Failed to track event:", eventName, error);
    }
  }
}

export function trackError(
  error: unknown,
  attributes: Record<string, string | number | boolean> = {},
): void {
  try {
    const errorObj = error instanceof Error ? error : new Error(String(error));
    const properties = normalizeAttributes(attributes);
    appInsights?.trackException({
      exception: errorObj,
      properties,
    });
  } catch (telemetryError) {
    if (process.env.NODE_ENV === "development") {
      console.debug("[Telemetry] Failed to track error:", telemetryError);
    }
  }
}
